import { isEmpty } from 'lodash'

import { hasAnySim, isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta10ExemplosEnum,
  ConsultaSeguimentoPergunta10Model,
} from './model-consultaSeguimentoPergunta10'

const pergunta10ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta10ExemplosEnum)

export function isPergunta10ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllFilled(allExemplos, pergunta10ExemplosEnumValues)
}

export function isPergunta10ExemplosAllNao(value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta10ExemplosEnumValues)
}

export function hasPergunta10ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta10ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta10Model['PERGUNTA_10_EXEMPLOS']
): boolean {
  const exemplosFalhou = value?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && hasAnySim(exemplosFalhou)
}

export function prunePergunta10(value: ConsultaSeguimentoPergunta10Model): ConsultaSeguimentoPergunta10Model {
  const pruned: ConsultaSeguimentoPergunta10Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_10_HEADER: value.PERGUNTA_10_HEADER,
    PERGUNTA_10_EXEMPLOS: value.PERGUNTA_10_EXEMPLOS,
  }

  const hasPerguntaExemplosPassouAnySim = hasPergunta10ExemplosPassouAnySim(value?.PERGUNTA_10_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta10ExemplosFalhouAnySim(value?.PERGUNTA_10_EXEMPLOS)

  if (hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
    pruned.PERGUNTA_10_FREQUENCIA = value.PERGUNTA_10_FREQUENCIA
  }

  return pruned
}
